







import { Vue, Component, Prop } from 'vue-property-decorator'
import { Post } from '~/themes/base/common/types'

@Component
export default class CineplexxWidget extends Vue {
  @Prop({ type: String, default: '' }) readonly title!: string
  @Prop({ type: Object, default: null })
  readonly initialData!: { search: { nodes: Post[] } } | null

  get cineplexxCode(): Post | null {
    if (
      !this.initialData ||
      (this.initialData.search?.nodes || []).length === 0
    ) {
      return null
    }
    return this.initialData.search.nodes[0]
  }
}
